import type {ReactAction} from '@netx/core/bootstrap';
import {faShare} from '@fortawesome/pro-solid-svg-icons';
import {UploadAssetRequestStatus} from '../schema';
import {
	canManageUploadAssetRequests,
	uploadAssetRequestEnabled,
} from '../enablers';
import {UploadAssetRequestsManageLabel} from '../locales';
import type {IUploadAssetRequest} from '../types';

export const uploadAssetRequestActionShareIcon = faShare;

export type UploadAssetRequestActionShareParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (uploadAssetRequest: IUploadAssetRequest) => void;
};

/**
 *
 * @param params
 * @returns Action
 */
export const uploadAssetRequestActionShare = (
	uploadAssetRequest: IUploadAssetRequest,
	{cb, ...params}: UploadAssetRequestActionShareParams,
): ReactAction => ({
	name: 'upload-asset-requests-share',
	cb: () => cb(uploadAssetRequest),
	enableTest: () =>
		uploadAssetRequestEnabled() && canManageUploadAssetRequests(),
	// Because why would we not... i don't agree with removing thsi check
	// &&
	// [
	// 	UploadAssetRequestStatus.ACTIVE,
	// 	UploadAssetRequestStatus.USER_DISABLED,
	// ].includes(uploadAssetRequest.status),
	icon: uploadAssetRequestActionShareIcon,
	label: UploadAssetRequestsManageLabel.SHARE,
	...params,
});
